
<h1>Por favor, chequeá que la información sea correcta antes de reservar.</h1>

<button class="btn btn-success btn-block btn-lg"
        (click)="ok()"
>
  <fa-icon *ngIf="loading" [icon]="faSpinner" spin="true"></fa-icon>
  Reservar
</button>
